export default __webpack_public_path__ + "static/media/logo.f2bee3c2.svg";